module.exports = __webpack_public_path__ + "SCTProfessional/static/dist/img/logo_regione_centrato.e3e332c4.png";